import { configureStore } from '@reduxjs/toolkit'
import { requestReducer } from '../api_request/slice'
import { loginReducer } from '../features/login/slice'
import { restReducer } from '../rest/slice'
import { bookEditorReducer } from '../features/books/edit/slice';
import { bookReaderReducer } from '../features/books/read/slice';

export const store = configureStore(
{
  reducer:
  {
    apiRequests: requestReducer,
    login: loginReducer,
    rest: restReducer,
    bookEditor: bookEditorReducer,
    bookReader: bookReaderReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof store.getState>;